import React, { ReactNode, useCallback, useState } from 'react';

import { ConditionalContentRenderer } from '../../../../../../shared/components/conditional-content-renderer';

interface Props {
    defaultContent: ReactNode;
    onHoverContent: ReactNode;
}

const useChangeContentOnHover = ({ defaultContent, onHoverContent }: Props) => {
    const [isButtonHovered, setButtonHover] = useState(false);
    const onMouseEnter = useCallback(() => {
        if (!isButtonHovered) {
            setButtonHover(true);
        }
    }, [isButtonHovered]);

    const onMouseLeave = useCallback(() => {
        if (isButtonHovered) {
            setButtonHover(false);
        }
    }, [isButtonHovered]);

    const HoverableContent = () => (
        <ConditionalContentRenderer condition={isButtonHovered} content={onHoverContent} fallback={defaultContent} />
    );
    return {
        isHover: isButtonHovered,
        onMouseEnter,
        onMouseLeave,
        HoverableContent: React.memo(HoverableContent),
    };
};

export default useChangeContentOnHover;
